/* eslint-disable @typescript-eslint/no-explicit-any -- aligné U3106ExpenseTypeListToolBar */
/* eslint-disable react-hooks/exhaustive-deps -- useMemo sur getSelectedRows() comme U3106 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';

import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000GridStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000GridStateHandlers';
import type { U2000TableHandlers } from '../../../u2000Core/types/U2000TableHandlers';
import { NS, U3203ROLES } from '../../U3203';
import type { U3203AiMissionSearchRow } from '../../U3203Service';
import { u2000CanManageScopeAwareEntity, u2000CanModifyU3203Mission } from '../../../u2000Core/tools/U2000SystemScopeAccess';

interface U3203AiMissionListToolBarProps {
  gridStateHandlers: U2000GridStateHandlers<U3203AiMissionSearchRow>;
  handlerActions?: U2000TableHandlers<U3203AiMissionSearchRow>;
}

export const U3203AiMissionListToolBar: React.FC<U3203AiMissionListToolBarProps> = ({
  gridStateHandlers,
  handlerActions,
}) => {
  const { t } = useTranslation();
  const { auth, hasRole } = useU2000AuthContext();

  const selectedRows = gridStateHandlers.getSelectedRows();
  const canModifyRow = (row: U3203AiMissionSearchRow) =>
    u2000CanModifyU3203Mission({
      isSystemScope: row.systemScope === true,
      hasEditRole: hasRole(U3203ROLES.EDIT),
      sessionOrganizationId: auth.user.organizationId,
    });
  const canDeleteRow = (row: U3203AiMissionSearchRow) =>
    u2000CanManageScopeAwareEntity({
      isSystemScope: row.systemScope === true,
      hasRequiredRole: hasRole(U3203ROLES.DELETE),
      sessionOrganizationId: auth.user.organizationId,
    });

  const disableUpdateBtn = React.useMemo(() => {
    return selectedRows.length !== 1 || selectedRows.some((row) => !canModifyRow(row));
  }, [selectedRows, auth.user.organizationId, hasRole]);

  const disableDeleteBtn = React.useMemo(() => {
    return selectedRows.length === 0 || selectedRows.some((row) => !canDeleteRow(row));
  }, [selectedRows, auth.user.organizationId, hasRole]);

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3203ROLES.ADD),
      handleClick: handlerActions?.onAdd,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3203ROLES.EDIT),
      handleClick: handlerActions?.onModify,
      disabled: disableUpdateBtn,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3203ROLES.DELETE),
      handleClick: handlerActions?.onDelete,
      disabled: disableDeleteBtn,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
